import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useSMA() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = () => {
    setLoading(true)

    api.get("/sma/")
    .then((res: SuccessFetch<{
      payload: {
        sma_id: number
        sma_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.sma_name, value: item.sma_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)

    api.get("/sma/").then((res: SuccessFetch<{
      payload: {
        sma_id: number
        sma_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.sma_name,
          value: item.sma_id?.toString()
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}